import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { SortableColumn } from '../../model/sort/sortable-column';
import { UserData } from '../../model/user-data';
import { UsersDataResponse } from '../../model/users-data-response';
import {COMMA, ENTER, T} from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { StoreService } from 'src/app/services/store.service';
import { sequence } from '@angular/animations';
import { StoreMaintainenceResponse } from '../../model/store-maintainence-response';

export interface Fruit {
  name: string;
}
@Component({
    selector: 'app-edit-store',
    templateUrl: './edit-store.component.html',
    styleUrls: ['./edit-store.component.scss'],
    standalone: false
})
export class EditStoreComponent implements OnInit {
  userAction:string=null;
  isDisabled: boolean = false;
  isHidden:boolean=false;
  user: UsersDataResponse;
  userData: UserData;
  storeEditForm: UntypedFormGroup;
  sortableColumn:SortableColumn;
  statusString:string;
  visible = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  emails:any=[];
  storeNumber:string;
  notes: string;
  lastUpdated: String;
  error: string;
  storeNumberError: string;
  errorMessage: string;
  
  constructor(private router: Router, private userservice: UserService,private fb: UntypedFormBuilder,
    private route:ActivatedRoute,private storeservice:StoreService) {
    
      this.createForm();
   
      this.userservice.getCurrentUser().subscribe(data => {
      this.user = data;
      this.userData = data.userData;
    })
  }

  
  ngOnInit() {
          //this.storeEditForm.setValidators([Validators.required]);
          this.storeEditForm.markAllAsTouched();
          this.storeEditForm.controls.storeNumber.disable();
          this.storeEditForm.controls.lastUpdatedTime.disable();
          this.storeEditForm.controls.dcNumber.disable();
          if (this.userData.roleId === 1) {
            this.storeEditForm.controls.storeLicenseNumber.enable();
            this.storeEditForm.controls.storeName.enable();
            //this.storeEditForm.controls.storeAddress.enable();
            this.storeEditForm.controls.civicNumber.enable();
            this.storeEditForm.controls.suiteNumber.enable();
            this.storeEditForm.controls.streetName.enable();
            this.storeEditForm.controls.streetType.enable();
            this.storeEditForm.controls.streetDirection.enable();
            this.storeEditForm.controls.storeEmails.enable();
            this.storeEditForm.controls.notes.enable();
            this.storeEditForm.controls.postalCode.enable();
            this.storeEditForm.controls.provinceCode.enable();
            this.storeEditForm.controls.city.enable();
          } else {
            this.storeEditForm.disable();
            this.storeEditForm.controls.storeEmails.enable();
          }
          this.route.params.subscribe(
            (params) => 
            { 
              let sequence=params.sequence;
              this.getStoreDetailsBySequence(sequence);
             })
  
  }

  add(event: MatChipInputEvent): void {
    const value = event.value;

    if (event.value) {
      if (this.validateEmail(event.value)) {  
        if ((value || '').trim()) {
          if(this.emails ===null){
            this.emails=[];
          }
          this.emails.push({ value: event.value, invalid: false });
        }
      }else {
        this.emails.push({ value: event.value, invalid: true }); 
      }
      this.updateEmailAddress();
      this.verifyAllEmails();
    }   
    // Reset the input value
    event.chipInput.clear();
  }

  verifyAllEmails(){
    try{
      this.storeEditForm.controls.storeEmails.value.forEach(item=>{
          if(!this.validateEmail(item)){
          this.storeEditForm.controls['storeEmails'].setErrors({'incorrectEmail': true});
          throw new Error("Invalid Emails");
          }else{
            this.storeEditForm.controls['storeEmails'].setErrors(null);
          }
        }) 
    }catch(error){
    console.log(error)
    }
  }

  updateEmailAddress(){
    let emails=[];
        this.emails.forEach(item=>{
          emails.push(item.value)
        })
        this.storeEditForm.patchValue({
          storeEmails:emails
    });
  }

  private validateArrayNotEmpty(c: UntypedFormControl) {
    if (c.value && c.value.length === 0) {
      return {
        validateArrayNotEmpty: { valid: false }
      };
    }
    return null;
  }

  remove(emailId:string): void {
    const index = this.emails.map(e => e.value).indexOf(emailId);

    if (index >= 0) {
      this.emails.splice(index, 1);
      this.updateEmailAddress();
    }
    this.verifyAllEmails();
  }

  getStoreDetailsBySequence(sequence){
   this.storeservice.getStoreBySequence(sequence).subscribe(data=>{
     let storeData:StoreMaintainenceResponse=data;
     
     storeData.storeEmails.forEach(item=>{
      this.emails.push({ value: item, invalid: false })
     });
     this.storeNumber=data.storeNumber;
     
      this.storeEditForm.patchValue({
        sequenceNumber:storeData.sequenceNumber,
        storeNumber: storeData.storeNumber,
        storeLicenseNumber:storeData.storeLicenseNumber,
        storeName:storeData.storeName,
        //storeAddress:storeData.storeAddress,
        civicNumber:storeData.civicNumber,
        suiteNumber:storeData.suiteNumber,
        streetName:storeData.streetName,
        streetType:storeData.streetType,
        streetDirection:storeData.streetDirection,
        city:storeData.city,
        provinceCode:storeData.provinceCode,
        postalCode:storeData.postalCode,
        dcNumber:storeData.dcNumber,
        storeEmails:storeData.storeEmails,
        notes:storeData.notes,
        lastUpdatedTime:storeData.lastUpdatedTime
        //lastUpdatedTime: storeData.lastUpdatedTime === null ? null : this.convertDateToUTC(new Date(storeData.lastUpdatedTime))
        //lastUpdatedTime: storeData.lastUpdatedTime === null ? null : this.createDateAsUTC(new Date(storeData.lastUpdatedTime))
      });  
   })
  }

  convertDateToUTC(date) { 
    return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds()); 
}

  createForm() {
    this.storeEditForm = this.fb.group({
      sequenceNumber:[],
      storeNumber: [null, Validators.required],
      storeLicenseNumber: [null,Validators.required],
      storeName: [null,Validators.required],
      //storeAddress: [null,Validators.required],
      civicNumber: [null],
      suiteNumber: [null],
      streetName: [null,Validators.required],
      streetType: [null],
      streetDirection: [null],
      city: [null,Validators.required],
      provinceCode: [null,Validators.required],
      postalCode: [null,Validators.required],
      dcNumber: [{value:null,disabled:true},Validators.required],
      storeEmails: [null,Validators.required],
      notes: [null],
      lastUpdatedTime: [null,Validators.required]
    });

  }


  setUserStatus(event:MatSlideToggleChange){
    this.statusString=event.checked==true?'Active':'Inactive';
  }

  updateStoreData(){
    this.storeEditForm.controls.sequenceNumber.enable();
    this.storeEditForm.controls.storeNumber.enable();
    this.updateEmailAddress();
    this.verifyAllEmails();
    this.storeservice.updateStore(this.storeEditForm.value).subscribe(data=>{
      this.backToSummary();
      },
      error => {
        console.log(error.message);
        //console.log(error.error);
        for (let [key, value] of Object.entries(error.error)) {
          //console.log(key);
          //console.log(value);         
          if(key.includes("storeEmails")){
            this.storeEditForm.controls["storeEmails"].setErrors({'invalid': value});
          }
          this.storeEditForm.controls[key].setErrors({'invalid': value});
        }
      })
  }

  backToSummary(){
    
    this.router.navigate(['/dcn-esign/store-management/store-maintainence']);
  }

  
  private validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

}
